import { r as registerInstance, c as createEvent, h, g as getElement } from './index-d4808923.js';
import { b as bem, g as global$1 } from './index.esm-7182addc.js';
import { g as gravityXSSWhitelist, l as lib, x as xss } from './gravity-xss-whitelist-53c2079f.js';

const gravityTabSetCss = ":host{display:block;height:100%}::slotted(gravity-tab){height:100%}.gravity-tab-set--sticky{display:flex;flex-direction:column;height:100%}.gravity-tab-set--sticky .gravity-tab-set__tab-body{flex:1 1 100%;overflow:hidden}.gravity-tab-set__tab-bar{background-color:#FFFFFF;box-shadow:inset 0 -1px 0 0 rgba(0, 15, 30, 0.05);box-sizing:border-box;display:flex;justify-content:space-between}.gravity-tab-set__tab-bar--variant-primary .gravity-tab-set__tab{padding:16px 24px 0}@media screen and (max-width: 1000px){.gravity-tab-set__tab-bar--variant-primary .gravity-tab-set__tab{padding:14px 16px 0}}.gravity-tab-set__tab-bar--variant-primary .tab-text{padding-bottom:16px}@media screen and (max-width: 1000px){.gravity-tab-set__tab-bar--variant-primary .tab-text{padding-bottom:14px}}.gravity-tab-set__tab-bar--variant-secondary .gravity-tab-set__tab{padding:14px 16px 0}@media screen and (max-width: 1000px){.gravity-tab-set__tab-bar--variant-secondary .gravity-tab-set__tab{padding:12px 16px 0}}.gravity-tab-set__tab-bar--variant-secondary .tab-text{padding-bottom:14px}@media screen and (max-width: 1000px){.gravity-tab-set__tab-bar--variant-secondary .tab-text{padding-bottom:12px}}.gravity-tab-set__tab-bar--variant-secondary:not(.gravity-tab-set__tab-bar--blank) .gravity-tab-set__tab--active{background-color:#F4F8FE}.gravity-tab-set__tab-bar--variant-secondary:not(.gravity-tab-set__tab-bar--blank) .gravity-tab-set__tab--active .tab-text::after{content:none}.gravity-tab-set__tab-bar--variant-tertiary{background-color:#F4F8FE}.gravity-tab-set__tab-bar--variant-tertiary .gravity-tab-set__tab{padding:12px 16px 0}.gravity-tab-set__tab-bar--variant-tertiary .gravity-tab-set__tab .tab-text{padding-bottom:12px}.gravity-tab-set__tab-bar--variant-tertiary .gravity-tab-set__tabs__nav-wrapper--prev{background:linear-gradient(to left, transparent, #F4F8FE 33%)}.gravity-tab-set__tab-bar--variant-tertiary .gravity-tab-set__tabs__nav-wrapper--next{background:linear-gradient(to right, transparent, #F4F8FE 33%)}@media screen and (max-width: 1000px){.gravity-tab-set__tab-bar--variant-tertiary:not(.gravity-tab-set__tab-bar--blank) .gravity-tab-set__tab--active{background-color:#F4F8FE}.gravity-tab-set__tab-bar--variant-tertiary:not(.gravity-tab-set__tab-bar--blank) .tab-text::after{content:none}}.gravity-tab-set__tab-bar--blank{background:transparent}.gravity-tab-set__tab-bar--blank .gravity-tab-set__nav-wrapper--position-prev,.gravity-tab-set__tab-bar--blank .gravity-tab-set__nav-wrapper--position-next{background:transparent}.gravity-tab-set__tabs-wrapper{display:flex;overflow:hidden;position:relative}.gravity-tab-set__tabs-wrapper--right-space{padding-right:56px}.gravity-tab-set__tabs-wrapper--left-space{padding-left:56px}.gravity-tab-set__tabs{display:flex;-ms-overflow-style:none;overflow-x:scroll;scrollbar-width:none;width:100%}.gravity-tab-set__tabs::-webkit-scrollbar{display:none}.gravity-tab-set__tabs a{text-decoration:none}.gravity-tab-set__tab{box-sizing:border-box;cursor:pointer;display:flex;position:relative;user-select:none;white-space:nowrap}.gravity-tab-set__tab .tab-text{align-items:center;box-sizing:border-box;display:flex;position:relative}.gravity-tab-set__tab:focus-visible:not(.gravity-tab-set__tab--disabled){border-radius:8px;outline:#1B6AEE solid 2px;outline-offset:-6px}.gravity-tab-set__tab--active .tab-text::after{background-color:#1B6AEE;bottom:0;content:\"\";height:2px;left:0;margin:0 auto;position:absolute;right:0}.gravity-tab-set__tab--disabled{cursor:default}.gravity-tab-set__nav-wrapper{align-items:center;bottom:0;display:none;justify-content:center;margin:1px 0;pointer-events:none;position:absolute;top:0;z-index:1}.gravity-tab-set__nav-wrapper--visible{display:flex}.gravity-tab-set__nav-wrapper__button{pointer-events:auto}.gravity-tab-set__nav-wrapper--position-prev{background:linear-gradient(to left, transparent, #FFFFFF 33%);left:0;padding-inline-end:24px;padding-inline-start:16px}.gravity-tab-set__nav-wrapper--position-next{background:linear-gradient(to right, transparent, #FFFFFF 33%);padding-inline-end:16px;padding-inline-start:24px;right:0}.gravity-tab-set__cta-buttons{align-items:center;display:flex}.gravity-tab-set__cta-buttons ::slotted([slot=cta]){padding:0 32px}@media screen and (max-width: 1000px){.gravity-tab-set__cta-buttons ::slotted([slot=cta]){padding:0 16px}}.gravity-tab-set__cta-buttons ::slotted([slot=cta][visibility=small]){display:none !important}@media screen and (max-width: 1000px){.gravity-tab-set__cta-buttons ::slotted([slot=cta][visibility=small]){display:initial !important}}.gravity-tab-set__cta-buttons ::slotted([slot=cta][visibility=large]){display:initial !important}@media screen and (max-width: 1000px){.gravity-tab-set__cta-buttons ::slotted([slot=cta][visibility=large]){display:none !important}}";
const GravityTabSetStyle0 = gravityTabSetCss;

const GravityTabSet = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.tabSelect = createEvent(this, "tabSelect", 7);
        this.generateClassNames = bem('gravity-tab-set');
        this.mostLeft = 0;
        this.mostRight = 0;
        this.navElementOffset = 65;
        this.tabDivs = [];
        this.xssOptions = {
            whiteList: Object.assign(Object.assign({}, gravityXSSWhitelist), lib.exports.whiteList),
        };
        this.blank = false;
        this.selected = undefined;
        this.sticky = false;
        this.variant = 'primary';
        this.hover = '';
        this.isScrolling = false;
        this.showNavNext = false;
        this.showNavPrev = false;
        this.tabs = [];
    }
    handleSelected(newValue, oldValue) {
        var _a;
        const tab = this.getTabById(newValue);
        if (!tab) {
            (_a = this.tabs) === null || _a === void 0 ? void 0 : _a.forEach((tab) => this.updateActiveStatus(tab.tabId, false));
            return;
        }
        if (tab.disabled && oldValue) {
            this.selected = oldValue;
            this.tabSelect.emit(oldValue);
            return;
        }
        this.setActiveTab(tab);
    }
    updateTabs() {
        if (this.tabs && this.tabs.length > 0) {
            this.previousTabsLength = this.tabs.length;
        }
        this.tabs = Array.from(this.element.querySelectorAll(':scope > gravity-tab'));
        // if an empty selected is provided and there is no active tab yet, render nothing
        if (this.selected === '') {
            return;
        }
        // Fall back to first not-disabled tab
        if (this.tabs && this.tabs.length > 0) {
            const index = this.tabs.findIndex((tab) => this.selected === tab.tabId);
            if (index === -1) {
                const firstNotDisabledTab = this.tabs.find((tab) => !tab.disabled);
                if (firstNotDisabledTab) {
                    this.selected = firstNotDisabledTab.tabId;
                    this.tabSelect.emit(firstNotDisabledTab.tabId);
                }
            }
        }
    }
    handleWindowResize() {
        this.updatePositions();
    }
    onMouseEnter(id) {
        this.hover = id;
    }
    onMouseLeave() {
        this.hover = '';
    }
    handleKeyDown(e, tab, idx) {
        if (e.key === 'Enter' || e.key === ' ') {
            this.selectTab(tab);
        }
        else if (e.key === 'ArrowRight') {
            this.focusNextTabLink(tab, idx);
        }
        else if (e.key === 'ArrowLeft') {
            this.focusPrevTabLink(tab, idx);
        }
        else if (e.key === 'Home') {
            this.focusFirstTab();
        }
        else if (e.key === 'End') {
            this.focusLastTab();
        }
    }
    focusNextTabLink(tab, currentIdx) {
        var _a, _b;
        const tabLinks = (_a = this.tabsDiv) === null || _a === void 0 ? void 0 : _a.querySelectorAll('a');
        if (!tabLinks || this.tabs.every((tab) => tab.disabled)) {
            return;
        }
        const nextIdx = (currentIdx + 1) % this.tabs.length;
        if (this.tabs[nextIdx].disabled) {
            this.focusNextTabLink(tab, nextIdx);
        }
        else {
            (_b = tabLinks[nextIdx]) === null || _b === void 0 ? void 0 : _b.focus();
        }
    }
    focusPrevTabLink(tab, currentIdx) {
        var _a, _b;
        const tabLinks = (_a = this.tabsDiv) === null || _a === void 0 ? void 0 : _a.querySelectorAll('a');
        const prevIdx = (currentIdx - 1 + this.tabs.length) % this.tabs.length;
        if (!tabLinks || this.tabs.every((tab) => tab.disabled)) {
            return;
        }
        if (this.tabs[prevIdx].disabled) {
            this.focusPrevTabLink(tab, prevIdx);
        }
        else {
            (_b = tabLinks[prevIdx]) === null || _b === void 0 ? void 0 : _b.focus();
        }
    }
    focusFirstTab() {
        var _a, _b;
        const tabs = (_a = this.tabsDiv) === null || _a === void 0 ? void 0 : _a.querySelectorAll('a');
        if (!tabs) {
            return;
        }
        let firstIdx = 0;
        while (this.tabs[firstIdx].disabled) {
            firstIdx = (firstIdx + 1) % this.tabs.length;
        }
        (_b = tabs[firstIdx]) === null || _b === void 0 ? void 0 : _b.focus();
    }
    focusLastTab() {
        var _a, _b;
        const tabs = (_a = this.tabsDiv) === null || _a === void 0 ? void 0 : _a.querySelectorAll('a');
        if (!tabs) {
            return;
        }
        let lastIdx = this.tabs.length - 1;
        while (this.tabs[lastIdx].disabled) {
            lastIdx = (lastIdx - 1 + this.tabs.length) % this.tabs.length;
        }
        (_b = tabs[lastIdx]) === null || _b === void 0 ? void 0 : _b.focus();
    }
    selectTab(tab) {
        if (tab.disabled) {
            return;
        }
        this.selected = tab.tabId;
        this.tabSelect.emit(tab.tabId);
    }
    setActiveTab(tab) {
        const href = tab.tabHref;
        this.tabs.forEach((tab) => this.updateActiveStatus(tab.tabId, false));
        this.updateActiveStatus(this.selected, true);
        this.scrollSelectedTabIntoView();
        // For anchor navigation to work for the new selected tab, we need to programmatically
        // navigate, as we can not pause propagation of actual anchor element click
        setTimeout(() => {
            // the regex is in place to account for Vue hash router link - https://github.com/redbullmediahouse/rbds-gravity/pull/1422
            if ((href === null || href === void 0 ? void 0 : href.includes('#')) && !/\/#\//.test(href)) {
                global$1.window.location.href = href;
            }
        }, 0);
    }
    scrollSelectedTabIntoView() {
        if (!this.tabDivs.length || !this.wrapper) {
            return;
        }
        const selectedTabDiv = this.tabDivs.find((tabDiv) => tabDiv.id === this.selected);
        if (!selectedTabDiv) {
            return;
        }
        const tabDivRect = selectedTabDiv.getBoundingClientRect();
        const wrapperRect = this.wrapper.getBoundingClientRect();
        const isTooLargeToFit = this.checkIfTooLargeToFit(tabDivRect, wrapperRect);
        const isOverlappedByPrevNavElement = this.checkIfOverlappedByPrevNavElement(tabDivRect);
        const isOverlappedByNextNavElement = this.checkIfOverlappedByNextNavElement(tabDivRect);
        if (isTooLargeToFit || isOverlappedByPrevNavElement) {
            this.scrollTo(tabDivRect.left - wrapperRect.left, -this.navElementOffset);
        }
        else if (isOverlappedByNextNavElement) {
            this.scrollTo(tabDivRect.right - wrapperRect.right, this.navElementOffset);
        }
    }
    checkIfTooLargeToFit(rect, wrapperRect) {
        return rect.width + 2 * this.navElementOffset > wrapperRect.width;
    }
    checkIfOverlappedByPrevNavElement(rect) {
        if (!this.wrapper || !rect) {
            return false;
        }
        const wrapperRect = this.wrapper.getBoundingClientRect();
        const overlap = rect.right - wrapperRect.left - rect.width;
        return overlap < this.navElementOffset;
    }
    checkIfOverlappedByNextNavElement(rect) {
        if (!this.wrapper || !rect) {
            return false;
        }
        return this.wrapper.getBoundingClientRect().right + 1 - rect.right < this.navElementOffset;
    }
    scrollTo(calculatedValue, offset) {
        if (!this.tabsDiv) {
            return;
        }
        const scrollValue = this.tabsDiv.scrollLeft + calculatedValue + offset;
        this.tabsDiv.scrollTo({ left: scrollValue, behavior: 'smooth' });
    }
    updateActiveStatus(id, active) {
        const tab = this.getTabById(id);
        if (tab) {
            tab.setActive(active);
        }
    }
    // eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
    getTabById(id) {
        var _a;
        return (_a = this.tabs) === null || _a === void 0 ? void 0 : _a.find((tab) => tab.tabId === id);
    }
    renderNav(position, visible) {
        const iconName = position === 'prev' ? 'arrow-left-outline' : 'arrow-right-outline';
        return (h("div", { class: this.generateClassNames('nav-wrapper', {
                position,
                visible,
            }) }, h("gravity-button", { class: this.generateClassNames('nav-wrapper__button'), iconName: iconName, onClick: () => this.scrollIntoView(position), type: "secondary" })));
    }
    scrollIntoView(position) {
        if (!this.wrapper || !this.tabDivs.length || this.isScrolling) {
            return;
        }
        const wrapperRect = this.wrapper.getBoundingClientRect();
        if (position === 'prev') {
            this.scrollPrevTabIntoView(wrapperRect, this.getRelevantRects(this.mostLeft, 'prev'));
        }
        else {
            this.scrollNextTabIntoView(wrapperRect, this.getRelevantRects(this.mostRight, 'next'));
        }
    }
    scrollPrevTabIntoView(wrapperRect, rect) {
        const targetRect = this.checkIfOverlappedByPrevNavElement(rect.neighbour) ? rect.neighbour : rect.edge;
        if (targetRect) {
            const scrollPosition = targetRect.left - wrapperRect.left;
            this.scrollTo(scrollPosition, -this.navElementOffset);
        }
    }
    scrollNextTabIntoView(wrapperRect, rect) {
        if (this.checkIfOverlappedByNextNavElement(rect.neighbour)) {
            this.scrollTo(rect.neighbour.right - wrapperRect.right, this.navElementOffset);
        }
        else {
            this.scrollTo(rect.edge.right - wrapperRect.right, this.navElementOffset);
        }
    }
    getRelevantRects(edgeIndex, position) {
        var _a;
        const direction = position === 'prev' ? -1 : 1;
        const edge = this.tabDivs[edgeIndex].getBoundingClientRect();
        const neighbour = (_a = this.tabDivs[edgeIndex + direction]) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        return { edge, neighbour };
    }
    updatePositions() {
        if (!this.tabsDiv || !this.wrapper) {
            return;
        }
        this.showNavPrev = this.tabsDiv.scrollLeft !== 0;
        this.updateShowNavNext();
        this.isScrolling = true;
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
        // wait for animation or scroll break
        this.timeout = global$1.window.setTimeout(() => {
            if (!this.wrapper) {
                return;
            }
            const left = this.wrapper.getBoundingClientRect().left;
            const newMostLeft = this.tabDivs.findIndex((div) => div.getBoundingClientRect().left - 1 - left > 0);
            // Fixes jumping of tabs when scrolling to end
            if (newMostLeft < this.tabDivs.length - 1) {
                this.mostLeft = newMostLeft;
            }
            this.updateMostRight();
            this.isScrolling = false;
        }, 300);
    }
    updateMostRight() {
        if (!this.tabDivs.length || !this.wrapper) {
            return;
        }
        const wrapperRect = this.wrapper.getBoundingClientRect();
        for (let i = this.tabDivs.length - 1; i >= 0; i--) {
            const tabRect = this.tabDivs[i].getBoundingClientRect();
            const isWithinWrapperWidth = tabRect.right - wrapperRect.left < wrapperRect.width;
            if (isWithinWrapperWidth) {
                this.mostRight = i;
                break;
            }
        }
    }
    updateShowNavNext() {
        if (!this.tabsDiv) {
            return;
        }
        const remainingScrollWidth = this.tabsDiv.scrollWidth - this.tabsDiv.scrollLeft - this.tabsDiv.clientWidth;
        this.showNavNext = remainingScrollWidth > 1;
    }
    componentWillLoad() {
        this.updateTabs();
        if (this.selected) {
            this.handleSelected(this.selected);
        }
    }
    componentDidLoad() {
        this.tabDivs = Array.from(this.element.shadowRoot.querySelectorAll('.gravity-tab-set__tab'));
        this.updateShowNavNext();
        this.updateMostRight();
    }
    componentDidRender() {
        if (this.previousTabsLength != this.tabs.length) {
            this.tabDivs = Array.from(this.element.shadowRoot.querySelectorAll('.gravity-tab-set__tab'));
            this.updateMostRight();
            this.updateShowNavNext();
        }
    }
    render() {
        return (h("div", { key: 'a63e272efdc26c63322b22e3769acd5b74d3e7c0', class: this.generateClassNames({ sticky: this.sticky }) }, h("div", { key: '5a7b9e58862dafe03880ab55a906b853ac7e6098', class: this.generateClassNames('tab-bar', { blank: this.blank, variant: this.variant }) }, h("div", { key: '87219df78306e4a51c27e906daaaee533a8c6db0', class: this.generateClassNames('tabs-wrapper', {
                'right-space': this.showNavNext,
                'left-space': this.showNavPrev,
            }), ref: (el) => (this.wrapper = el) }, this.renderNav('prev', this.showNavPrev), h("div", { key: '5c1d6d26ffcfeab492eed59364aa01fff15a82ab', class: this.generateClassNames('tabs'), ref: (el) => (this.tabsDiv = el), onScroll: () => this.updatePositions() }, this.tabs.map((tab, idx) => (h("a", { class: this.generateClassNames('tab', {
                active: this.selected === tab.tabId,
                disabled: !!tab.disabled,
            }), id: tab.tabId, onClick: () => this.selectTab(tab), onKeyDown: (e) => this.handleKeyDown(e, tab, idx), onMouseEnter: () => this.onMouseEnter(tab.tabId), onMouseLeave: () => this.onMouseLeave(), href: tab.tabHref ? tab.tabHref : undefined, tabIndex: this.selected === tab.tabId ? 0 : -1 }, h("gravity-text", { class: "tab-text", size: this.variant === 'tertiary' ? 'xx-small' : 'x-small', weight: "medium", color: this.selected === tab.tabId || (this.hover === tab.tabId && !tab.disabled)
                ? 'primary'
                : tab.disabled
                    ? 'dark-muted'
                    : 'dark-subtle', innerHTML: xss(tab.heading, this.xssOptions) }))))), this.renderNav('next', this.showNavNext)), h("div", { key: 'ae2d99ec9a38219b5ed9f3a14bb55483153bab15', class: this.generateClassNames('cta-buttons') }, h("slot", { key: '204d05c9a5b70c76ce3e7253e4073d5e85555b54', name: "cta", onSlotchange: () => this.updatePositions() }))), h("div", { key: '628fe41803ef024ffb75e52ae85b5c33acaf2936', class: this.generateClassNames('tab-body') }, h("slot", { key: '276123d6281faf1a568170d54c7821414ac5a858', onSlotchange: () => this.updateTabs() }))));
    }
    get element() { return getElement(this); }
    static get watchers() { return {
        "selected": ["handleSelected"]
    }; }
};
GravityTabSet.style = GravityTabSetStyle0;

export { GravityTabSet as gravity_tab_set };

//# sourceMappingURL=gravity-tab-set.entry.js.map